import React, {
	Component
} from 'react';
import styled from 'styled-components';
import { store } from '../stores/mainStore';
// import { ButtonBar } from './UI';
import {observer} from 'mobx-react';

const ExitPage = styled.div`
	padding-top: ${p =>  0}%;
	box-sizing: border-box;
	width: 100%;
	height: 100%;
	background: rgba(0,0,0, 0.75);
	display: flex;
	justify-content: center;
	align-items: center;
	color: white;
	font-size: 32px;
	pointer-events: auto;
`

const Content = styled.div`
	display: flex;
	width: ${p => 100}%;
	height: 100%;
	padding-top: 0%;
	box-sizing: border-box;
	background-size: 100% auto;
	text-align: center;
	flex-direction: column;
`

const BoxContent = styled.img`
	width: ${p => 100}%;
`

@observer
export class ModalVideoDimPanel extends Component {

    componentDidMount() {
		store.videoCloseButtonVisible = true;
        // setTimeout(() => {
		// 	store.videoCloseButtonVisible = true;
		// 	// this.showButton();
        // }, 4000);
	}
	showButton() {
		store.videoCloseButtonVisible = true;
        // setTimeout(() => {
		// 	store.videoCloseButtonVisible = false;
        // }, 8000);
	}
    cancel() {
		window.manager.ui.extraRollButtonPressed = false;
        store.modal = '';
    }

	render() {

		return (
			<ExitPage>
				<Content>
                {store.videoCloseButtonVisible === true && (
				<BoxContent src={`/assets/box_no_ad_available.png`} onClick={this.cancel}/>
                )}
				</Content>
			</ExitPage>
		);
	}
}
